import {Routes, Route, Link} from 'react-router-dom';

export default function Socials () {
    return (
        <div id="landingMain">
            <div className="row" id="name">
                <div className="col"><Link to={"/"}>JAY "KURZWIEL" OYEBADEJO</Link></div>
            </div>
            <div className="row nav">
                <div className="col-6">
                    <a href="http://www.instagram.com/jaykurzweil">INSTAGRAM</a>
                </div>
                <div className="col-6">
                    <a href="http://twitter.com/jaykurzweil">TWITTER</a>
                </div>
                {/* <div className="col-4">
                    <a href="">INSTAGRAM</a>
                </div> */}
            </div>
        </div>
    )
}